export const RoomTagSchema = {
  RO: "فقط اتاق",
  BB: "همراه با صبحانه",
  HB: "صبحانه و نهار",
  BD: "صبحانه و شام",
  BS: "صبحانه و یک وعده غذایی",
  FB: "صبحانه، نهار، شام",
  AI: "ALL / همه وعده‌های غذایی",
  UAI: "UALL / همه وعده‌های غذایی ۲۴ ساعته",
  EXTRA_BED: "تخت اضافه",
  CHILD_WITHOUT_BED: "کودک بدون تخت"
};

export const BoardTypesSchema = {
  RO: { label: "بدون غذا", icon: "no_food" },
  BB: { label: "صبحانه", icon: "emoji_food_beverage" },
  HB: { label: "صبحانه و نهار", icon: "fastfood" },
  BD: { label: "صبحانه و شام", icon: "dinner_dining" },
  BS: { label: "صبحانه و یک وعده غذایی", icon: "lunch_dining" },
  FB: { label: "صبحانه، نهار و شام", icon: "local_dining" },
  AI: { label: "صبحانه، نهار، شام، میان وعده", icon: "flatware" },
  UAI: {
    label: "Uall",
    icon: "tapas"
  }
};

export const ErrorBookSchema = {
  UNKNOWN: {
    title: "مشکل در رزرو تور",
    description:
      "متاسفانه مشکلی در رزرو تور پیش آمده است. لطفا دوباره جستجو کنید و تور دیگری را انتخاب کنید.",
    button: "جستجوی مجدد",
    page: "result"
  },
  FLIGHT: {
    title: "مشکل در رزرو بلیط پرواز",
    description:
      "متاسفانه مشکلی در رزرو بلیط پرواز این تور پیش آمده است. لطفا دوباره جستجو کنید و پرواز دیگری را انتخاب کنید.",
    button: "تغییر پرواز",
    page: "room"
  },
  HOTEL: {
    title: "مشکل در رزرو اتاق",
    description:
      "متاسفانه مشکلی در رزرو اتاق این تور پیش آمده است. لطفا دوباره جستجو کنید و اتاق دیگری را انتخاب کنید.",
    button: "تغییر اتاق",
    page: "room"
  }
};

export const trainesSchema = {
  raja: {
    id: 1,
    enLabel: "Raja",
    faLabel: "رجا",
    logoCdnUrl: "RJA.png"
  },
  noor_alreza: {
    id: 2,
    enLabel: "Noor Alreza",
    faLabel: "نورالرضا",
    logoCdnUrl: "NRZ.png"
  },
  mahtab_seir: {
    id: 3,
    enLabel: "Mahtab Seir Jam",
    faLabel: "مهتاب سیرجام",
    logoCdnUrl: "MSJ.png"
  },
  reil_seir: {
    id: 4,
    enLabel: "Reil Seir",
    faLabel: "ریل سیر کوثر",
    logoCdnUrl: "RSK.png"
  },
  reil_tarabar: {
    id: 5,
    enLabel: "Reil Tarabar",
    faLabel: "ریل ترابر سبا",
    logoCdnUrl: "RTS.png"
  },
  bon_reil: {
    id: 6,
    enLabel: "Bon Reil",
    faLabel: "بن ریل",
    logoCdnUrl: "BNR.png"
  },
  joopar: {
    id: 7,
    enLabel: "Joopar",
    faLabel: "جوپار",
    logoCdnUrl: "JPR.png"
  },
  fadak_economy: {
    id: 8,
    enLabel: "Fadak",
    faLabel: "فدک",
    logoCdnUrl: "FDK.png"
  }
};

export const AirlinesSchema = {
  EP: {
    id: 1,
    enLabel: "Aseman",
    faLabel: "آسمان",
    logoCdnUrl: "aseman.png"
  },
  W5: {
    id: 2,
    enLabel: "Mahan",
    faLabel: "ماهان",
    logoCdnUrl: "mahan.png"
  },
  HH: {
    id: 3,
    enLabel: "Taban",
    faLabel: "تابان",
    logoCdnUrl: "taban.png"
  },
  QB: {
    id: 4,
    enLabel: "Qeshm Air",
    faLabel: "قشم ایر",
    logoCdnUrl: "qeshmair.png"
  },
  NV: {
    id: 6,
    enLabel: "Karun (Naft)",
    faLabel: "کارون (نفت)",
    logoCdnUrl: "naft.png"
  },
  TF: {
    id: 8,
    enLabel: "Taftan",
    faLabel: "تفتان",
    logoCdnUrl: "taftan.png"
  },
  ZV: {
    id: 9,
    enLabel: "Zagros",
    faLabel: "زاگرس",
    logoCdnUrl: "zagros.png"
  },
  IR: {
    id: 10,
    enLabel: "Iran Air",
    faLabel: "ایران ایر",
    logoCdnUrl: "iranair.png"
  },
  I3: {
    id: 11,
    enLabel: "Ata",
    faLabel: "آتا",
    logoCdnUrl: "ata.png"
  },
  B9: {
    id: 14,
    enLabel: "Iran Airtour",
    faLabel: "ایران ایرتور",
    logoCdnUrl: "iranairtour.png"
  },
  AK: {
    id: 16,
    enLabel: "Atrak",
    faLabel: "اترک",
    logoCdnUrl: "atrak.png"
  },
  HE: {
    id: 17,
    enLabel: "Hesa",
    faLabel: "هسا",
    logoCdnUrl: ""
  },
  H8: {
    id: 18,
    enLabel: "Sepahan",
    faLabel: "سپاهان",
    logoCdnUrl: "sepahan.png"
  },
  DZD: {
    id: 26,
    enLabel: "Yazd",
    faLabel: "یزد ایر",
    logoCdnUrl: "yazd.png"
  },
  AXV: {
    id: 27,
    enLabel: "Ava",
    faLabel: "آوا",
    logoCdnUrl: "ava.png"
  },
  SE: {
    id: 15,
    enLabel: "Saha",
    faLabel: "ساها",
    logoCdnUrl: "saha.png"
  },
  SA: {
    id: 15,
    enLabel: "Saha",
    faLabel: "ساها",
    logoCdnUrl: "saha.png"
  },
  IRZ: {
    id: 15,
    enLabel: "Saha",
    faLabel: "ساها",
    logoCdnUrl: "saha.png"
  },
  ZZ: {
    id: 15,
    enLabel: "Saha",
    faLabel: "ساها",
    logoCdnUrl: "saha.png"
  },
  RZ: {
    id: 15,
    enLabel: "Saha",
    faLabel: "ساها",
    logoCdnUrl: "saha.png"
  },
  VA: {
    id: 19,
    enLabel: "Varesh",
    faLabel: "وارش",
    logoCdnUrl: "varesh.png"
  },
  VR: {
    id: 19,
    enLabel: "Varesh",
    faLabel: "وارش",
    logoCdnUrl: "varesh.png"
  },
  IRU: {
    id: 23,
    enLabel: "Chabahar",
    faLabel: "چابهار",
    logoCdnUrl: "chabahar.png"
  },
  IU: {
    id: 23,
    enLabel: "Chabahar",
    faLabel: "چابهار",
    logoCdnUrl: "chabahar.png"
  },
  RI: {
    id: 23,
    enLabel: "Chabahar",
    faLabel: "چابهار",
    logoCdnUrl: "chabahar.png"
  },
  IRC: {
    id: 23,
    enLabel: "Chabahar",
    faLabel: "چابهار",
    logoCdnUrl: "chabahar.png"
  },
  FP: {
    id: 21,
    enLabel: "Fly Persia",
    faLabel: "فلای پرشیا",
    logoCdnUrl: "flypersia.png"
  },
  FPI: {
    id: 21,
    enLabel: "Fly Persia",
    faLabel: "فلای پرشیا",
    logoCdnUrl: "flypersia.png"
  },
  PRS: {
    id: 22,
    enLabel: "Pars Air",
    faLabel: "پارس ایر",
    logoCdnUrl: "parsair.png"
  },
  PA: {
    id: 22,
    enLabel: "Pars Air",
    faLabel: "پارس ایر",
    logoCdnUrl: "parsair.png"
  },
  SJT: {
    id: 24,
    enLabel: "Asajet",
    faLabel: "آساجت",
    logoCdnUrl: "asajet.png"
  },
  A7: {
    id: 24,
    enLabel: "Asajet",
    faLabel: "آساجت",
    logoCdnUrl: "asajet.png"
  },
  A1: {
    id: 25,
    enLabel: "Air1",
    faLabel: "اروان",
    logoCdnUrl: "air1.png"
  },
  INA: {
    id: 25,
    enLabel: "Air1",
    faLabel: "اروان",
    logoCdnUrl: "air1.png"
  },
  IV: {
    id: 5,
    enLabel: "Caspian",
    faLabel: "کاسپین",
    logoCdnUrl: "caspian.png"
  },
  RV: {
    id: 5,
    enLabel: "Caspian",
    faLabel: "کاسپین",
    logoCdnUrl: "caspian.png"
  },
  CPN: {
    id: 5,
    enLabel: "Caspian",
    faLabel: "کاسپین",
    logoCdnUrl: "CPN.png"
  },
  Y9: {
    id: 7,
    enLabel: "Kish Air",
    faLabel: "کیش ایر",
    logoCdnUrl: "kishair.png"
  },
  KIA: {
    id: 7,
    enLabel: "Kish Air",
    faLabel: "کیش ایر",
    logoCdnUrl: "kishair.png"
  },
  IS: {
    id: 12,
    enLabel: "Sepehran",
    faLabel: "سپهران",
    logoCdnUrl: "sepehran.png"
  },
  SR: {
    id: 12,
    enLabel: "Sepehran",
    faLabel: "سپهران",
    logoCdnUrl: "sepehran.png"
  },
  JI: {
    id: 13,
    enLabel: "Meraj",
    faLabel: "معراج",
    logoCdnUrl: "meraj.png"
  },
  J1: {
    id: 13,
    enLabel: "Meraj",
    faLabel: "معراج",
    logoCdnUrl: "meraj.png"
  },
  PY: {
    id: 20,
    enLabel: "Pouya",
    faLabel: "پویا",
    logoCdnUrl: "pouya.png"
  },
  PYA: {
    id: 20,
    enLabel: "Pouya",
    faLabel: "پویا",
    logoCdnUrl: "pouya.png"
  },
  ATS: {
    id: 21,
    enLabel: "Atlas",
    faLabel: "اطلس",
    logoCdnUrl: "pouya.png"
  },
  TI: {
    id: 22,
    enLabel: "Tailwind",
    faLabel: "تیلویند ایرلاینز",
    logoCdnUrl: "pouya.png"
  },
  PC: {
    id: 23,
    enLabel: "Pegasus",
    faLabel: "پگاسوس",
    logoCdnUrl: "Pegasus.png"
  },
  VF: {
    id: 24,
    enLabel: "AJet",
    faLabel: "ای جت",
    logoCdnUrl: "AJet.png"
  },
  G9: {
    id: 25,
    enLabel: "Air arabia",
    faLabel: "ایر عربیا",
    logoCdnUrl: "AirArabia.png"
  },
  FZ: {
    id: 26,
    enLabel: "Fly Dubai",
    faLabel: "فلای دوبی",
    logoCdnUrl: "FlyDubai.png"
  },
  EK: {
    id: 27,
    enLabel: "Air arabia",
    faLabel: "هواپیمایی امارات",
    logoCdnUrl: "AirArabia.png"
  },
  RAI: {
    id: 28,
    enLabel: "RAIMON Airlines",
    faLabel: "هواپیمایی رایمون",
    logoCdnUrl: "RAIMONAirlines.png"
  },
  TKN: {
    id: 37,
    enLabel: "flykish",
    faLabel: "فلای کیش",
    logoCdnUrl: "TKN.png"
  },
  TK: {
    id: 38,
    enLabel: "turkish air",
    faLabel: "ترکیش ایر",
    logoCdnUrl: "TK.png"
  },
  _KO: {
    id: 39,
    enLabel: "Komiaviatrans",
    faLabel: "کومی‌اویاترنس",
    logoCdnUrl: "_KO.png"
  },
  KO: {
    id: 40,
    enLabel: "Komiaviatrans",
    faLabel: "کومی‌اویاترنس",
    logoCdnUrl: "KO.png"
  },
  MEH: {
    id: 40,
    enLabel: "Mehr",
    faLabel: "مهر ایرلاین",
    logoCdnUrl: "MEH.png"
  },
  NSM: {
    id: 41,
    enLabel: "Nasim air",
    faLabel: "نسیم ایر",
    logoCdnUrl: "NSM.png"
  },
  NSN: {
    id: 42,
    enLabel: "NSN",
    faLabel: "هواپیمایی نسیم",
    logoCdnUrl: "NSN.png"
  },
  LMB: {
    id: 43,
    enLabel: "LMB",
    faLabel: "هواپیمایی لاد",
    logoCdnUrl: "LMB.png"
  }
};

export const HotelRatings = [
  { minRate: 0, text: "", color: "error" },
  { minRate: 2, text: "", color: "warning" },
  { minRate: 3, text: "", color: "default" },
  { minRate: 3.5, text: "خوب", color: "default" },
  { minRate: 4, text: "خیلی خوب", color: "success" },
  { minRate: 4.5, text: "عالی", color: "success" }
];

export const GeneralTagsSchema = {
  FREE_TRANSFER: {
    text: "ترانسفر رایگان",
    color: "#EBECF2"
  },
  FREE_INSURANCE: {
    text: "بیمه مسافرتی رایگان",
    color: "#EBECF2"
  },
  WITH_VISA: {
    text: "به همراه ویزا",
    color: "success"
  },
  NO_VISA: {
    text: "بدون ویزا",
    color: "error"
  }
};
